import { environmentShared } from './environment.shared';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration production` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	name: 'test',
	demo: false,
	baseUrl: 'https://apitest.powerkiosk.com',
	baseAPIUrl: 'https://apitest.powerkiosk.com',
	graphQLEndpoint: 'https://graphqltest.powerkiosk.com/graphql',
	apiKey: '',
	stripeKey: 'pk_test_7YXS6tuhvcq8NkQjV92IA8kY',
	helpScoutBeaconId: 'ea621574-188a-4803-98a7-72753b75e0d2',
	userflowId: 'ct_us1_ifugmm7vzbeyvdf56i2h3wy7yu',
	...environmentShared,
};
